/*
 * @Author: your name
 * @Date: 2020-03-04 14:30:51
 * @LastEditTime: 2024-02-03 18:22:08
 * @LastEditors: dengfang 36882215@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /fle-basic-template/src/main.js
 */
import Vue from 'vue'
import ElementUI from 'element-ui'
// import VueAnalytics from 'vue-analytics'
import '@/assets/styles/index.scss'
import '@/assets/styles/index.scss'

import App from './App'
import store from './store'
import router from './router'
import i18n from './lang'
import '@/assets/icons'
import '@/router/permission'
import { axiosRequest } from './util/axios-request'
import { util } from './util/util'
import mixin from './util/mixin'
import s from 'storejs'
import './util/directive'
import './util/origin-extend'
import VueDOMPurifyHTML from 'vue-dompurify-html'

// 接入日志平台
// const mode = process.env.MODE
// ;(async function () {
//   if (!['training'].includes(process.env.MODE) && process.env.NODE_ENV !== 'development') {
//     const ErrorCapture = (await import('@flash-tools/error-capture')).default
//     const capture = new ErrorCapture({
//       pid: process.env.ERROR_PID,
//       mode: mode === 'trunk' ? 'development' : 'production',
//       performance: true
//       // igonre: params => {
//       //   const { info } = params
//       //   const stack = ['Network Error', 'removeChild'].some(v => info.stack.includes(v))
//       //   if (stack) return true
//       // }
//     })
//     Vue.use(capture)
//   }
// })()

Vue.prototype.$http = axiosRequest
Vue.prototype.$util = util
Vue.prototype.$p = util.permissionCheck
Vue.prototype.$s = s
Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueDOMPurifyHTML)
Vue.config.productionTip = false

Vue.mixin(mixin)
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
// Vue.use(VueAnalytics, {
//   id: 'UA-183876102-2'
// })
